const Spacer = () => {
    return(
        <div className="mb-20"></div>
    )
};

export default Spacer;